function resolvedActionIdSet(resolvedActionIds) {
  if (resolvedActionIds instanceof Set) return resolvedActionIds;
  return new Set(Array.isArray(resolvedActionIds) ? resolvedActionIds : []);
}

function hideResolvedActionsInRecommendation(recommendation, resolvedActionIds) {
  if (!recommendation || typeof recommendation !== 'object') return recommendation;
  const resolvedIds = resolvedActionIdSet(resolvedActionIds);
  if (resolvedIds.size === 0 || !Array.isArray(recommendation.proposed_actions)) return recommendation;

  const proposedActions = recommendation.proposed_actions.filter(action => (
    action?.status !== 'pending' || !resolvedIds.has(action?.action_id)
  ));
  if (proposedActions.length === recommendation.proposed_actions.length) return recommendation;
  return { ...recommendation, proposed_actions: proposedActions };
}

function quarantineMissingActionsInRecommendation(recommendation, quarantinedActionIds) {
  if (!recommendation || typeof recommendation !== 'object' || !Array.isArray(recommendation.proposed_actions)) return recommendation;
  const quarantinedIds = resolvedActionIdSet(quarantinedActionIds);
  if (quarantinedIds.size === 0) return recommendation;
  return {
    ...recommendation,
    proposed_actions: recommendation.proposed_actions.map(action => (
      action?.status === 'pending' && quarantinedIds.has(action?.action_id)
        ? { ...action, status: 'missing' }
        : action
    )),
  };
}

export function hideResolvedCoachActions(recommendations, resolvedActionIds) {
  if (!recommendations || typeof recommendations !== 'object') return recommendations || {};
  return Object.fromEntries(Object.entries(recommendations).map(([exerciseId, recommendation]) => [
    exerciseId,
    hideResolvedActionsInRecommendation(recommendation, resolvedActionIds),
  ]));
}

export function replaceExerciseRecommendations(_current, incoming, resolvedActionIds, quarantinedActionIds) {
  const visible = hideResolvedCoachActions(incoming || {}, resolvedActionIds);
  return Object.fromEntries(Object.entries(visible).map(([exerciseId, recommendation]) => [
    exerciseId,
    quarantineMissingActionsInRecommendation(recommendation, quarantinedActionIds),
  ]));
}

export function mergeExerciseRecommendation(current, exerciseId, incoming, resolvedActionIds, quarantinedActionIds) {
  return {
    ...(current || {}),
    [exerciseId]: quarantineMissingActionsInRecommendation(
      hideResolvedActionsInRecommendation(incoming, resolvedActionIds),
      quarantinedActionIds,
    ),
  };
}
